module.exports = __webpack_public_path__ + "static/media/csharp.8959dafa.svg";